import { APP_STORE_URL, PLAY_STORE_URL } from '@/lib/links'

export function AppPreview() {
  return (
    <section
      style={{
        padding: '80px 24px 120px',
        background:
          'linear-gradient(180deg, #F8FAFF 0%, #EFF6FF 50%, #F5F0FF 100%)',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '700px',
          height: '400px',
          background:
            'radial-gradient(ellipse, rgba(99,102,241,0.06) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: '#EEF2FF',
              border: '1px solid #C7D2FE',
              borderRadius: '100px',
              padding: '6px 16px',
              marginBottom: '20px',
            }}
          >
            <span
              style={{
                fontSize: '12px',
                letterSpacing: '0.5px',
                color: '#6366F1',
                fontWeight: '600',
              }}
            >
              App Experience
            </span>
          </div>
          <h2
            style={{
              fontSize: 'clamp(28px, 3.5vw, 46px)',
              fontWeight: '800',
              letterSpacing: '-1px',
              color: '#0F172A',
              margin: '0 0 16px',
            }}
          >
            Clean. Fast.{' '}
            <span
              style={{
                background: 'linear-gradient(135deg, #6366F1, #3B82F6)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Effortless.
            </span>
          </h2>
          <p
            style={{
              fontSize: '17px',
              color: '#6B7280',
              maxWidth: '400px',
              margin: '0 auto',
            }}
          >
            Available on iOS, Android, and the web. Get verified from anywhere.
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
            gap: '24px',
            flexWrap: 'wrap',
          }}
        >
          <div
            style={{
              transform: 'rotate(-7deg) translateY(24px)',
              opacity: 0.75,
            }}
          >
            <MiniPhone variant="list" />
          </div>
          <div style={{ transform: 'translateY(0)', zIndex: 2 }}>
            <MiniPhone variant="main" />
          </div>
          <div
            style={{
              transform: 'rotate(7deg) translateY(24px)',
              opacity: 0.75,
            }}
          >
            <MiniPhone variant="success" />
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '16px',
            marginTop: '60px',
            flexWrap: 'wrap',
          }}
        >
          <StoreBadge store="apple" />
          <StoreBadge store="google" />
        </div>
      </div>
    </section>
  )
}

function MiniPhone({ variant }: { variant: 'main' | 'list' | 'success' }) {
  const isMain = variant === 'main'
  const width = isMain ? 220 : 180
  const height = isMain ? 440 : 360

  return (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
        background: 'linear-gradient(160deg, #FFFFFF, #F8FAFF)',
        borderRadius: `${isMain ? 36 : 30}px`,
        border: '1.5px solid #E5E7EB',
        padding: '12px',
        boxShadow: isMain
          ? '0 32px 64px rgba(59,130,246,0.15), 0 8px 20px rgba(0,0,0,0.06)'
          : '0 16px 32px rgba(0,0,0,0.08)',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <div
        style={{
          width: '70px',
          height: '20px',
          background: '#F1F5F9',
          borderRadius: '0 0 14px 14px',
          margin: '0 auto 12px',
        }}
      />

      {variant === 'main' && (
        <div style={{ padding: '4px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '16px',
            }}
          >
            <div>
              <div
                style={{
                  fontSize: '13px',
                  fontWeight: '800',
                  color: '#0F172A',
                }}
              >
                GetCode
              </div>
              <div style={{ fontSize: '10px', color: '#94A3B8' }}>
                Dashboard
              </div>
            </div>
            <div
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '8px',
                background: 'linear-gradient(135deg, #3B82F6, #6366F1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                fontWeight: '800',
                color: 'white',
                boxShadow: '0 2px 8px rgba(59,130,246,0.3)',
              }}
            >
              G
            </div>
          </div>

          <div
            style={{
              background: 'linear-gradient(135deg, #EFF6FF, #EDE9FE)',
              border: '1.5px solid #C7D2FE',
              borderRadius: '12px',
              padding: '12px',
              marginBottom: '12px',
            }}
          >
            <div
              style={{ fontSize: '9px', color: '#6B7280', marginBottom: '4px' }}
            >
              Balance
            </div>
            <div
              style={{ fontSize: '22px', fontWeight: '800', color: '#0F172A' }}
            >
              $12.40
            </div>
          </div>

          {[
            '🇺🇸 WhatsApp · 286 491',
            '🇬🇧 Google · 947 183',
            '🇩🇪 Telegram · 574 220',
          ].map((item, i) => (
            <div
              key={i}
              style={{
                background: '#F8FAFF',
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                padding: '8px 10px',
                marginBottom: '6px',
                fontSize: '9px',
                color: '#374151',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span>{item}</span>
              <span style={{ color: '#10B981', fontWeight: '700' }}>✓</span>
            </div>
          ))}
        </div>
      )}

      {variant === 'list' && (
        <div style={{ padding: '4px' }}>
          <div
            style={{
              fontSize: '11px',
              fontWeight: '800',
              color: '#0F172A',
              marginBottom: '12px',
            }}
          >
            Choose Service
          </div>
          {[
            '💬 WhatsApp',
            '✈️ Telegram',
            '🔵 Google',
            '📸 Instagram',
            '🎮 Discord',
          ].map((s, i) => (
            <div
              key={i}
              style={{
                background: i === 0 ? '#EFF6FF' : '#F8FAFF',
                border: `1px solid ${i === 0 ? '#BFDBFE' : '#E5E7EB'}`,
                borderRadius: '8px',
                padding: '8px 10px',
                marginBottom: '6px',
                fontSize: '10px',
                color: i === 0 ? '#3B82F6' : '#6B7280',
                fontWeight: i === 0 ? '600' : '400',
              }}
            >
              {s}
            </div>
          ))}
        </div>
      )}

      {variant === 'success' && (
        <div
          style={{
            padding: '4px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '20px',
          }}
        >
          <div
            style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              background: '#F0FDF4',
              border: '1.5px solid #BBF7D0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '22px',
              marginBottom: '10px',
              boxShadow: '0 4px 12px rgba(16,185,129,0.15)',
            }}
          >
            ✅
          </div>
          <div
            style={{
              fontSize: '11px',
              fontWeight: '800',
              color: '#0F172A',
              marginBottom: '4px',
              textAlign: 'center',
            }}
          >
            Code Received!
          </div>
          <div
            style={{
              fontSize: '20px',
              fontWeight: '800',
              letterSpacing: '5px',
              background: 'linear-gradient(135deg, #3B82F6, #6366F1)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              marginBottom: '8px',
            }}
          >
            724 891
          </div>
          <div
            style={{ fontSize: '9px', color: '#9CA3AF', textAlign: 'center' }}
          >
            Verified · 2.1s delivery
          </div>
        </div>
      )}
    </div>
  )
}

function StoreBadge({ store }: { store: 'apple' | 'google' }) {
  const isApple = store === 'apple'
  const src = isApple ? '/App-Store-Badge.png' : '/Google-Play-Badge.png'
  const alt = isApple ? 'Available on the App Store' : 'Get it on Google Play'
  const href = isApple ? APP_STORE_URL : PLAY_STORE_URL

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-block',
        textDecoration: 'none',
        transition: 'all 0.25s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)'
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          display: 'block',
          height: '56px',
          width: 'auto',
          maxWidth: 'min(42vw, 220px)',
          borderRadius: '12px',
          boxShadow: '0 8px 24px rgba(15,23,42,0.14)',
        }}
      />
    </a>
  )
}
